module.exports = __webpack_public_path__ + "img/insureTotal.5768330a.png";